export default __webpack_public_path__ + "static/media/defient_app-store.1dee9ea1.svg";